﻿// NG 2
import { Injectable, Provider } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';


@Injectable()
export class AppConfig {
    static config: any;

    constructor(private http: Http) { }   

    load(): Promise<any> {
        var promise = this.http.get('./appsetting.json').map(res => res.json()).toPromise();        
        promise.then(config => AppConfig.config = config.default);
        return promise;
    }
}

